import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconFirstPageStyle0 = gravityIconIndividualCss;

const GravityIconFirstPage = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '8a2f67ffe5683a727be173f541bac778cab004ac', color: this.color, size: this.size }, h("svg", { key: '1274173f6c6d2cf91bad96d30aba57ea365d8d64', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'fa6c40582cb22fe05c8c8fbcb0e05f7c99759ec9', d: "M5 4.5a.5.5 0 0 1 .5-.5H6a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-13Zm10.614 13.336-6.455-6.443a.565.565 0 0 1 0-.786l6.455-6.443a.553.553 0 0 1 .786 0l.387.387a.565.565 0 0 1 0 .786l-5.668 5.658 5.668 5.668a.565.565 0 0 1 0 .786l-.387.387a.553.553 0 0 1-.786 0Z", fill: "currentColor" }))));
    }
};
GravityIconFirstPage.style = GravityIconFirstPageStyle0;

export { GravityIconFirstPage as gravity_icon_first_page };

//# sourceMappingURL=gravity-icon-first-page.entry.js.map